import React from 'react'
import { IonList, IonItem, IonCol, IonRow, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { useDispatch, useSelector } from 'react-redux'
import { setAddressType } from '../../home/store/home.actions'
import { getHomeSelector } from '../../home/selectors/getHome.selector'
import { getFactorsAffectingCareSelector } from '../../factorsAffectingCare/selectors'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { INemsisCustomDataOptions } from '../../options/store/options.types'
import { getNemsisCustomDataOptionsSelector } from '../../options/selectors'

const DispatchList: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const { hideComponent } = useSelector(getHomeSelector)
  const factorsAffectingCare = useSelector(getFactorsAffectingCareSelector)
  const serviceConfig = useSelector(getServiceConfigSelector)
  const { hideNemsisCustomOption }: INemsisCustomDataOptions = useSelector(getNemsisCustomDataOptionsSelector)

  const { PR_EXPOSURE } = serviceConfig
  const { showFactors, showDispatchFactors, showTurnAroundFactors, showResponseSceneTransportFactors } =
    factorsAffectingCare

  const showNotImplementedAlert = () => {
    alert('Not implemented')
  }

  const onTripInformationClick = () => {
    history.push(TabConstants.TRIP_INFORMATION)
  }

  const onExposureClick = () => {
    history.push(TabConstants.EXPOSURE)
  }

  const OnNemsisDataClick = () => {
    history.push(TabConstants.NEMSIS_DATA)
  }

  const onPickupAddressClick = () => {
    dispatch(setAddressType(1))
    history.push(TabConstants.PICKUP_ADDRESS)
  }

  const onDestinationAddressClick = () => {
    dispatch(setAddressType(2))
    history.push(TabConstants.DESTINATION_ADDRESS)
  }

  const onFactorsAffectingCareClick = () => {
    history.push(TabConstants.FACTORS_AFFECTING_CARE)
  }

  const onSceneDescriptionClick = () => {
    history.push(TabConstants.SCENE_DESCRIPTION)
  }

  return (
    <IonList>
      <IonItem data-testid='TripInformation' onClick={onTripInformationClick}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.dispatch.TripInformation')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.dispatch.PriorityNatureAndDisposition')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      <IonItem data-testid='PickupAddress' onClick={onPickupAddressClick}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.dispatch.PickupAddress')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.dispatch.LocationAndDetailsOfPatientScene')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      <IonItem data-testid='SceneDescription' onClick={onSceneDescriptionClick}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.dispatch.SceneDescription')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.dispatch.DetailsOfSceneAndOtherRespondingAgencies')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      {hideComponent && (
        <IonItem data-testid='OtherServicesAtScene' onClick={showNotImplementedAlert}>
          <IonCol className='ion-padding'>
            <IonRow>
              <IonLabel color='dark'>
                <h2>{t('fullChart.dispatch.OtherServicesAtScene')}</h2>
              </IonLabel>
            </IonRow>
            <IonRow>
              <IonLabel color='medium'>
                <h3>{t('fullChart.dispatch.AssistingEMSAndAdditionalTransportLegs')}</h3>
              </IonLabel>
            </IonRow>
          </IonCol>
        </IonItem>
      )}
      <IonItem data-testid='DestinationAddress' onClick={onDestinationAddressClick}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.dispatch.DestinationAddress')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.dispatch.LocationAndDetailsOfReceivingFacility')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      {(showFactors || showDispatchFactors || showTurnAroundFactors || showResponseSceneTransportFactors) && (
        <IonItem data-testid='FactorsAffectingCare' onClick={onFactorsAffectingCareClick}>
          <IonCol className='ion-padding'>
            <IonRow>
              <IonLabel color='dark'>
                <h2>{t('fullChart.dispatch.FactorsAffectingCare')}</h2>
              </IonLabel>
            </IonRow>
            <IonRow>
              <IonLabel color='medium'>
                <h3>{t('fullChart.dispatch.DispatchResponseAndOtherFactors')}</h3>
              </IonLabel>
            </IonRow>
          </IonCol>
        </IonItem>
      )}
      {PR_EXPOSURE === 1 && (
        <IonItem data-testid='Exposure' onClick={onExposureClick}>
          <IonCol className='ion-padding'>
            <IonRow>
              <IonLabel color='dark'>
                <h2>{t('fullChart.dispatch.Exposure')}</h2>
              </IonLabel>
            </IonRow>
            <IonRow>
              <IonLabel color='medium'>
                <h3>{t('fullChart.dispatch.ExposureDetailsProtectiveEquipment')}</h3>
              </IonLabel>
            </IonRow>
          </IonCol>
        </IonItem>
      )}
      {!hideNemsisCustomOption && (
        <IonItem data-testid='NemsisData' onClick={OnNemsisDataClick}>
          <IonCol className='ion-padding'>
            <IonRow>
              <IonLabel color='dark'>
                <h2>{t('fullChart.dispatch.NemsisData')}</h2>
              </IonLabel>
            </IonRow>
            <IonRow>
              <IonLabel color='medium'>
                <h3>{t('fullChart.dispatch.NemsisCustomStateElements')}</h3>
              </IonLabel>
            </IonRow>
          </IonCol>
        </IonItem>
      )}
    </IonList>
  )
}

export default DispatchList
